import React, { createElement, useEffect, useState } from 'react';
import './index.scss';
import { Axis, Chart, Tooltip, Interval, View, Line, Point, Legend, registerShape, } from 'bizcharts';
import { previewDataByField } from '../../../api/common/index';
import { Message } from '@alifd/next';
import { dealArray, dealOrderByBoList, dealFieldByList } from '../../../utils';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
registerShape('interval', 'border-radius', {
    draw(cfg, container) {
        const { points, color, defaultStyle } = cfg;
        let path = [];
        path.push(['M', points[0].x, points[0].y]);
        path.push(['L', points[1].x, points[1].y]);
        path.push(['L', points[2].x, points[2].y]);
        path.push(['L', points[3].x, points[3].y]);
        path.push('Z');
        path = this.parsePath(path);
        const style = { ...defaultStyle };
        if (color) {
            style.fill = color;
        }
        const group = container.addGroup();
        const width = path[2][1] - path[1][1];
        const height = width / 2;
        const radius = width / 2;
        const disY = path[0][2] - path[1][2];
        const startY = path[0][2] - height / 2;
        const endY = disY > 0 ? path[1][2] + height / 2 : path[1][2] - height / 2;
        const num = width / 4;
        const h = startY - endY;
        const flag = h > radius;
        group.addShape('rect', {
            attrs: {
                x: path[1][1],
                y: endY + (flag ? num : -num),
                width,
                height: disY + (flag ? -2 * num : 0),
                fill: style.fill,
            },
            zIndex: 0,
        });
        if (flag) {
            group.addShape('rect', {
                attrs: {
                    x: path[1][1],
                    y: endY - num,
                    width,
                    height: width,
                    fill: style.fill,
                    radius,
                },
                zIndex: 2,
            });
        }
        return group;
    },
});
const legendMap = {};
const BarLineGroup = (props, ref) => {
    const { dataSource, data, styleType, theme, lineTheme, color, xAxis, yAxis, legend, label, style, barCircle, hasTitle, titleText, } = props;
    let config = {
        xProps: 'item',
        ybProps: '柱状图',
        ylProps: '折线图',
        series: 'series',
        dfl: ['line'],
    };
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [idata, setIdata] = useState([]);
    const [ldata, setLdata] = useState([]);
    const [yaxish, setYaxish] = useState([]);
    const [yaxisl, setYaxisl] = useState([]);
    useEffect(() => {
        setError(false);
        try {
            if (dataSource?.xaxis?.length && (dataSource?.yaxish?.length || dataSource?.yaxisl?.length)) {
                const limit = dataSource?.limit || [100];
                if (limit[0] > 1000) {
                    Message.error('最多显示前1000条!');
                    return;
                }
                const fl = dataSource?.filter || [];
                const params = {
                    groupId: dataSource.dataset.id,
                    type: 'BarLineGroup',
                    fieldList: dealFieldByList([
                        ...dataSource.xaxis,
                        ...dataSource?.yaxish,
                        ...dataSource?.yaxisl,
                    ]),
                    horizontalAxis: dealArray(dataSource.xaxis),
                    longitudinalAxis: dealArray([...dataSource?.yaxish, ...dataSource?.yaxisl]).map((e) => ({
                        ...e,
                        aggregateType: e?.aggregateType || 'COUNT',
                    })),
                    orderByBoList: dealOrderByBoList(dataSource.xaxis),
                    resultCount: limit[0] === undefined ? 100 : limit[0],
                    customFilterVo: fl[0] === undefined
                        ? null
                        : {
                            logic: 'and',
                            filterVos: [dataSource?.filter[0] || null],
                        },
                };
                previewDataByField(params).then((res) => {
                    const fields = res?.data?.fields;
                    if (!fields) {
                        Message.error(res?.msg);
                        return;
                    }
                    const xp = fields.find((e) => e.id === dataSource.xaxis[0].id)?.fieldShortName || 'defalut';
                    let data = [];
                    let Ldata = [];
                    res.data.data.map((e) => {
                        for (let item of dataSource.yaxish) {
                            data.push({
                                [config.xProps]: e[xp],
                                [config.ybProps]: Number(e[item.fieldShortName]),
                                [config.series]: item.name,
                            });
                        }
                        for (let item of dataSource.yaxisl) {
                            legendMap[item.name] = true;
                            Ldata.push({
                                [config.xProps]: e[xp],
                                [config.ylProps]: Number(e[item.fieldShortName]),
                                [config.series]: item.name,
                            });
                        }
                        return e;
                    });
                    if (dataSource?.xaxis[0]?.additional?.sort) {
                        let sortArr = dataSource?.xaxis[0]?.additional?.sort.filter((e) => e.checked);
                        const datalist = [];
                        const ldataList = [];
                        sortArr.forEach((item) => {
                            data.forEach((itm) => {
                                if (itm.item === item.name) {
                                    datalist.push(itm);
                                }
                            });
                            Ldata.forEach((itm) => {
                                if (itm.item === item.name) {
                                    ldataList.push(itm);
                                }
                            });
                        });
                        data = datalist;
                        Ldata = ldataList;
                    }
                    setYaxish(dataSource.yaxish.map((e) => e.name));
                    setYaxisl(dataSource.yaxisl.map((e) => e));
                    setIdata(data);
                    setLdata(Ldata);
                });
            }
            else {
                setIdata(data.map((e) => ({ ...e, 柱状图: e.value })));
                setLdata(data.slice(0, 7).map((e) => ({ ...e, 折线图: e.value })));
                setYaxish(['London', 'Berlin']);
                setYaxisl([{ fieldShortName: 'line', name: '折线图' }]);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('初始化数据出错,请在数据源面板重新配置字段或更新组件');
        }
    }, [dataSource]);
    const [names, setNames] = useState([]);
    useEffect(() => {
        try {
            setNames(Array.from(new Set(idata.map((e) => e[config.series]))));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('图例解析出错,请更新组件或检查数据来源合法性');
        }
    }, [idata]);
    const colorArr = color ? color?.split(',') : [];
    const [myTheme, setMyTheme] = useState({});
    const [mySize, setMySize] = useState(15);
    useEffect(() => {
        try {
            if (theme) {
                const { maxColumnWidth, minColumnWidth, size } = theme;
                setMyTheme({ maxColumnWidth, minColumnWidth });
                setMySize(Math.min(Math.max(size, minColumnWidth), maxColumnWidth));
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('柱体宽度配置出错,请在属性面板检查宽度字段');
        }
    }, [theme]);
    let chartIns = null;
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, style: style, className: "base_bg" },
        hasTitle ? (createElement("div", { className: "datasettitle" }, titleText || dataSource?.dataset?.name)) : null,
        createElement(Chart, { height: 400, padding: [50, 60], theme: styleType === 'custom' ? myTheme : {}, data: idata, autoFit: true, onGetG2Instance: (chart) => {
                chartIns = chart;
            }, scale: {
                [config.ybProps]: {
                    type: 'linear',
                    min: yAxis?.min || (yAxis.min === 0 ? 0 : null),
                    max: yAxis?.max || (yAxis.max === 0 ? 0 : null),
                    tickCount: yAxis?.tickCount,
                },
                [config.ylProps]: {
                    type: 'linear',
                    min: yAxis?.min || (yAxis.min === 0 ? 0 : null),
                    max: yAxis?.max || (yAxis.max === 0 ? 0 : null),
                    tickCount: yAxis?.tickCount,
                },
            }, forceUpdate: true },
            createElement(Tooltip, { shared: true }),
            createElement(Interval, Object.assign({ adjust: "dodge", color: [config.series, colorArr], label: {
                    fields: label?.visible ? [config.ybProps] : [],
                    cfg: label?.displayType === 'custom'
                        ? {
                            style: {
                                fontSize: label?.style?.fontSize,
                                fill: label?.style?.autoFill ? '#000000' : label.style?.fill,
                            },
                            ...(label?.style?.autoPosition ? {} : { position: label?.style?.position }),
                        }
                        : {},
                } }, (styleType === 'custom' ? { size: mySize } : {}), { position: `${config.xProps}*${config.ybProps}`, shape: [
                    `1*2`,
                    (date, val) => {
                        if (val === 0) {
                            return;
                        }
                        if (barCircle) {
                            return 'border-radius';
                        }
                        return 'rect';
                    },
                ] })),
            createElement(Axis, Object.assign({ name: config.xProps }, {
                visible: xAxis?.visible,
                line: xAxis?.line,
                tickLine: xAxis?.tickLine,
                title: xAxis?.showTitle && {
                    text: xAxis?.title,
                },
                label: xAxis?.label &&
                    (xAxis?.labelType === 'defalut'
                        ? {}
                        : {
                            style: {
                                fill: xAxis?.labelColor,
                                fontSize: xAxis?.labelSize,
                                width: xAxis?.labelLength === 'fixed'
                                    ? xAxis?.labelFixedWidth
                                    : xAxis?.labelPercentWidth,
                            },
                            autoHide: xAxis?.autoHide,
                            autoRotate: xAxis?.autoRotate,
                            ...{
                                ...(xAxis?.autoRotate
                                    ? {}
                                    : { rotate: (xAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                            },
                        }),
                grid: xAxis?.grid,
            })),
            createElement(Axis, Object.assign({ name: config.ybProps }, {
                visible: yAxis?.visible,
                line: yAxis?.line,
                tickLine: yAxis?.tickLine,
                title: yAxis?.showTitle && {
                    text: yAxis?.title,
                },
                label: yAxis?.label &&
                    (yAxis?.labelType === 'defalut'
                        ? {}
                        : {
                            style: {
                                fill: yAxis?.labelColor,
                                fontSize: yAxis?.labelSize,
                                width: yAxis?.labelLength === 'fixed'
                                    ? yAxis?.labelFixedWidth
                                    : yAxis?.labelPercentWidth,
                            },
                            autoHide: yAxis?.autoHide,
                            autoRotate: yAxis?.autoRotate,
                            ...(yAxis?.autoRotate
                                ? {}
                                : { rotate: (yAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                        }),
                grid: yAxis?.grid,
            }, { title: {
                    position: 'end',
                    offset: -20,
                    autoRotate: false,
                } })),
            createElement(View, { data: ldata, padding: 0 },
                lineTheme?.showDot ? (createElement(Point, { position: `${config.xProps}*${config.ylProps}`, color: [config.series, colorArr.slice(yaxish.length)], size: lineTheme?.dotSize, shape: lineTheme?.dotShape })) : null,
                createElement(Line, { shape: lineTheme?.smooth ? 'smooth' : 'line', size: lineTheme?.lineSize || 2, position: `${config.xProps}*${config.ylProps}`, color: [config.series, colorArr.slice(yaxish.length)] }),
                createElement(Axis, { visible: false, name: config.xProps }),
                createElement(Axis, Object.assign({ position: "right", name: config.ylProps }, {
                    visible: yAxis?.visible,
                    line: yAxis?.line,
                    tickLine: yAxis?.tickLine,
                    title: yAxis?.showTitle && {
                        text: yAxis?.title,
                    },
                    label: yAxis?.label &&
                        (yAxis?.labelType === 'defalut'
                            ? {}
                            : {
                                style: {
                                    fill: yAxis?.labelColor,
                                    fontSize: yAxis?.labelSize,
                                    width: yAxis?.labelLength === 'fixed'
                                        ? yAxis?.labelFixedWidth
                                        : yAxis?.labelPercentWidth,
                                },
                                autoHide: yAxis?.autoHide,
                                autoRotate: yAxis?.autoRotate,
                                ...(yAxis?.autoRotate
                                    ? {}
                                    : { rotate: (yAxis?.labelRotateAngle * 2 * Math.PI) / 180 }),
                            }),
                    grid: yAxis?.grid,
                }, { title: {
                        position: 'end',
                        offset: -20,
                        autoRotate: false,
                    } }))),
            createElement(Legend, { position: legend?.position, custom: true, items: [
                    ...names.map((e, i) => {
                        return {
                            name: e,
                            value: e,
                            marker: {
                                symbol: 'square',
                                style: { fill: colorArr[i] },
                            },
                        };
                    }),
                    ...yaxisl.map((e, i) => {
                        return {
                            name: e.name,
                            value: e.fieldShortName,
                            marker: {
                                symbol: 'hyphen',
                                style: { stroke: colorArr[names.length + i], lineWidth: 2 },
                            },
                        };
                    }),
                ], onChange: (ev) => {
                    const { item } = ev;
                    const { name, value } = item;
                    const checked = !item.unchecked;
                    legendMap[name] = checked;
                    if (yaxisl.some((e) => e.fieldShortName === value)) {
                        const view = chartIns.views[0];
                        view.filter(config.series, (val) => {
                            return legendMap[val];
                        });
                        view.render(true);
                    }
                    else {
                        ev.view.filter(config.series, (val) => {
                            return legendMap[val] !== false;
                        });
                        ev.view.render(true);
                    }
                } }))))));
};
export default React.forwardRef(BarLineGroup);
